import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "initials", "input"]

  connect() {
    this._previewUrl = null
  }

  disconnect() {
    this.#revokePreview()
  }

  preview() {
    const file = this.inputTarget.files[0]
    if (!file || !file.type.startsWith("image/")) return

    this.#revokePreview()
    this._previewUrl = URL.createObjectURL(file)
    this.previewTarget.src = this._previewUrl
    this.previewTarget.classList.remove("hidden")

    if (this.hasInitialsTarget) {
      this.initialsTarget.classList.add("hidden")
    }
  }

  #revokePreview() {
    if (this._previewUrl) {
      URL.revokeObjectURL(this._previewUrl)
      this._previewUrl = null
    }
  }
}
